import * as Sentry from '@sentry/react';

export function captureApiError(operation: 'merchant' | 'submit', error: unknown): void {
  const tags = { api_operation: operation };
  if (error instanceof Response) {
    const reason = error.ok ? 'returned an unexpected response' : 'request failed';
    Sentry.captureException(new Error(`${operation} ${reason} (HTTP ${error.status})`), {
      tags: { ...tags, http_status: String(error.status) },
      extra: { status: error.status },
    });
    return;
  }

  Sentry.captureException(
    error instanceof Error || error instanceof DOMException ?
      error
    : new Error(`${operation} request failed`),
    { tags }
  );
}
